import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import "../result/result.css";
import { Link } from 'react-router-dom';
// import Sidebar from '../../components/Sidebar';
import AlertMessage from "../../AlertMessage";
import TemplateResultView from './TemplateResultView';

const BoardResult = () => {
  const [academicYear, setAcademicYear] = useState('');
  const [classValue, setClassValue] = useState('');
  const [selectedExamName, setSelectedExamName] = useState('');
  const [studentData, setStudentData] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [marksData, setMarksData] = useState({});
  const [classes, setClasses] = useState([]);
  const [selectedStudentResults, setSelectedStudentResults] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [schoolName, setSchoolName] = useState('');
  const [schoolLogo, setSchoolLogo] = useState('');
  const [division, setDivision] = useState("");
  const [divisions, setDivisions] = useState([]);
  const udiseNumber = localStorage.getItem("udiseNumber");
  const examNames = ['First Semester', 'Second Semester', 'All Exams', 'Template'];
  const examNameTranslations = {
    "First Semester": "à¤ªà¥à¤°à¤¥à¤® à¤¸à¤¤à¥à¤°",
    "Second Semester": "à¤¦à¥à¤µà¤¿à¤¤à¥€à¤¯ à¤¸à¤¤à¥à¤°",
    "All Exams": "à¤¸à¤°à¥à¤µ à¤ªà¤°à¥€à¤•à¥à¤·à¤¾",
    "Template": "à¤¨à¤®à¥à¤¨à¤¾",
  };
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);



  useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage("");
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);



  useEffect(() => {
    const fetchDefaultSettings = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/defaultSettings.json`);
        if (response.ok) {
          const data = await response.json();

          if (data) {
            setAcademicYear(data.defaultYear || "");
          }
        } else {
          console.error("Failed to fetch default settings.");
        }
      } catch (error) {
        console.error("Error fetching default settings:", error);
      }
    };

    fetchDefaultSettings();
  }, [udiseNumber]);

  const [subjectSequence, setSubjectSequence] = useState([]); // New state for subject sequence
  useEffect(() => {
    if (academicYear && classValue) {
      fetchSubjectSequence();
    }
  }, [academicYear, classValue]);

  const fetchSubjectSequence = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/subjectSequence/${academicYear}/${classValue}.json`
      );
      if (!response.ok) {
        throw new Error('Failed to fetch subject sequence');
      }
      const data = await response.json();
      // Assuming the data is an object with numeric keys
      const orderedSubjects = Object.keys(data)
        .sort((a, b) => parseInt(a) - parseInt(b)) // Sort by numeric keys
        .map((key) => data[key]); // Map keys to subject names
      setSubjectSequence(orderedSubjects);
    } catch (error) {
      console.error('Error fetching subject sequence:', error);
    }
  };


  useEffect(() => {
    const storedLanguage = localStorage.getItem('language') || 'English';
    setLanguage(storedLanguage);
  }, []);



  const fetchSchoolName = async () => {
    try {
      const db = await openDB();
      const transaction = db.transaction(SCHOOL_STORE, 'readonly');
      const store = transaction.objectStore(SCHOOL_STORE);

      // Get the school data using the udiseNumber as key
      const request = store.get(udiseNumber);

      request.onsuccess = (event) => {
        const schoolData = event.target.result;
        if (schoolData) {
          // Set school name and logo from IndexedDB
          setSchoolName(schoolData.schoolName || '-');
          setSchoolLogo(schoolData.schoolLogo || '');

          // Update language if available in school data
          if (schoolData.language) {
            setLanguage(schoolData.language);
            localStorage.setItem('language', schoolData.language);
          }
        } else {
          console.log('No school data found in IndexedDB');
          // Fallback to empty values if no data found
          setSchoolName('-');
          setSchoolLogo('');
        }
      };

      request.onerror = (event) => {
        console.error('Error fetching school data from IndexedDB:', event.target.error);
        // Fallback to empty values on error
        setSchoolName('-');
        setSchoolLogo('');
      };
    } catch (error) {
      console.error('Error accessing IndexedDB:', error);
      // Fallback to empty values on error
      setSchoolName('-');
      setSchoolLogo('');
    }
  };

  useEffect(() => {
    fetchSchoolName();
    fetchStudentData();

  }, [udiseNumber]); // Add udiseNumber as dependency

  useEffect(() => {
    if (selectedExamName && classValue && academicYear) {
      fetchMarksForSelectedSubject();
    }
  }, [selectedExamName, classValue, academicYear]);

  const handleAcademicYearChange = (e) => setAcademicYear(e.target.value);
  // const handleClassChange = (e) => {
  //   setClassValue(e.target.value);
  //   fetchSubjectsForClass(e.target.value);
  // };
  const handleExamNameChange = (e) => {
    // Prevent changing the selected exam name from "Second Semester" or "All Exams" or "Template"
    if (e.target.value !== "Second Semester" && e.target.value !== "All Exams" && e.target.value !== "Template") {
      return;
    }
    setSelectedExamName(e.target.value);
  };

  const filteredExamNames = examNames.filter((examName) => examName === "Second Semester" || examName === "All Exams" || examName === "Template");

  // IndexedDB constants
  const DB_NAME = 'SchoolManagementDB';
  const STUDENT_STORE = 'studentData';
  const DB_VERSION = 1;
  const ATTENDANCE_STORE = 'attendance';


  const SCHOOL_STORE = 'schoolData';


  // Function to open IndexedDB
  const openDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(DB_NAME, DB_VERSION);

      request.onerror = (event) => {
        console.error("IndexedDB error:", event.target.error);
        reject(event.target.error);
      };

      request.onsuccess = (event) => {
        const db = event.target.result;
        resolve(db);
      };

      request.onupgradeneeded = (event) => {
        const db = event.target.result;

        // Create object stores if they don't exist
        if (!db.objectStoreNames.contains(STUDENT_STORE)) {
          db.createObjectStore(STUDENT_STORE, { keyPath: "id" });
        }

        // Add SCHOOL_STORE if it doesn't exist
        if (!db.objectStoreNames.contains(SCHOOL_STORE)) {
          db.createObjectStore(SCHOOL_STORE, { keyPath: "udiseNumber" });
        }
      };
    });
  };
  // Function to fetch student data from IndexedDB
  const fetchStudentData = async () => {
    try {
      const db = await openDB();
      if (!db) {
        console.error("Error: db object is not initialized");
        return;
      }

      const transaction = db.transaction(STUDENT_STORE, "readonly");
      const store = transaction.objectStore(STUDENT_STORE);
      const request = store.getAll();

      request.onsuccess = (event) => {
        const allStudents = event.target.result;

        // Filter out students where isActive is false
        const activeStudents = allStudents.filter(student =>
          student.isActive !== false
        );

        const classesAndDivisions = {};
        activeStudents.forEach((student) => {
          if (student && student.currentClass) {
            if (!classesAndDivisions[student.currentClass]) {
              classesAndDivisions[student.currentClass] = {};
            }

            const division = student.division || "";
            if (!classesAndDivisions[student.currentClass][division]) {
              classesAndDivisions[student.currentClass][division] = [];
            }

            // Use the ID as the serial number equivalent 
            classesAndDivisions[student.currentClass][division].push(student.id);
          }
        });

        // Extract class, division, and srNo from key 
        const updatedStudents = activeStudents.map((student) => {
          const keyParts = student.id.split("-"); // Split by "-" 
          const className = keyParts[0]; // First part is class 
          const division = keyParts[1]; // Second part is division 
          const srNo = keyParts[keyParts.length - 1]; // Last part is srNo 
          return { ...student, className, division, srNo };
        });

        setClasses(Object.keys(classesAndDivisions));
        setStudentData(updatedStudents); // Store updated students 
      };

      request.onerror = (event) => {
        console.error("Error fetching student data from IndexedDB:", event.target.error);
      };
    } catch (error) {
      console.error("Error fetching student data:", error);
    }
  };

  const fetchDivisionsForClass = async (classValue) => {
    try {
      const db = await openDB();
      const transaction = db.transaction(STUDENT_STORE, "readonly");
      const store = transaction.objectStore(STUDENT_STORE);
      const request = store.getAll(); // Fetch all students

      request.onsuccess = (event) => {
        const students = event.target.result;
        const divisionsForClass = new Set();

        students.forEach((student) => {
          if (student.currentClass === classValue) {
            divisionsForClass.add(student.division);
          }
        });

        setDivisions(Array.from(divisionsForClass)); // Update divisions state
      };

      request.onerror = (event) => {
        console.error("Error fetching divisions from IndexedDB:", event.target.error);
      };
    } catch (error) {
      console.error("Error opening IndexedDB:", error);
    }
  };

  // Load student data and marks from IndexedDB
  useEffect(() => {
    const loadData = async () => {
      try {
        const db = await openDB();
        await fetchStudentData(db);
      } catch (error) {
        console.error("Error loading data from IndexedDB:", error);
      }
    };

    loadData();
  }, []);


  const handleClassChange = async (e) => {
    const selectedClass = e.target.value;
    setClassValue(selectedClass); // Update the class value
    setDivision(""); // Reset division when class changes
    fetchSubjectsForClass(e.target.value);

    if (selectedClass) {
      await fetchDivisionsForClass(selectedClass);
    }

    // Filter students based on the selected class
    const filteredStudents = studentData.filter((student) => student.currentClass === selectedClass);
    setSelectedStudents(filteredStudents);
  };





  const fetchSubjectsForClass = async (classValue) => {
    try {
      if (!academicYear) {
        console.error('Academic year is not set');
        return;
      }
    } catch (error) {
      console.error(`Error fetching subjects for class ${classValue} and academic year ${academicYear}:`, error);
    }
  };

  const fetchMarksForSelectedSubject = async () => {
    try {
      const selectedStudents = studentData.filter(
        (student) => student.currentClass === classValue
      );
      setSelectedStudents(selectedStudents);
      const marksDataPromises = selectedStudents.map(async (student) => {
        const studentMarks = await fetchMarksData(
          student.srNo,
          academicYear,
          selectedExamName
        );
        return { srNo: student.srNo, marks: studentMarks };
      });

      const marksDataArray = await Promise.all(marksDataPromises);
      const marksData = marksDataArray.reduce((acc, { srNo, marks }) => {
        acc[srNo] = marks;
        return acc;
      }, {});

      setMarksData(marksData);
    } catch (error) {
      console.error('Error fetching marks data:', error);
    }
  };

  const fetchMarksData = async (key, academicYear, examName) => {
    try {
      console.log('Fetching Marks Data with:', {
        key,
        academicYear,
        examName
      });

      const db = await openDB();
      const transaction = db.transaction(STUDENT_STORE, "readonly");
      const store = transaction.objectStore(STUDENT_STORE);

      // Find the correct key based on the numeric identifier
      const allKeys = await new Promise((resolve, reject) => {
        const keysRequest = store.getAllKeys();
        keysRequest.onsuccess = (event) => resolve(event.target.result);
        keysRequest.onerror = (event) => reject(event.target.error);
      });

      // Improved key matching to handle more flexible key formats
      const matchingKey = allKeys.find(storeKey =>
        typeof storeKey === 'string' &&
        (storeKey.endsWith(`-${key}`) || storeKey === key)
      );

      console.log('Matching Key:', matchingKey);

      if (!matchingKey) {
        console.warn('No matching key found for:', key);
        return null;
      }

      const request = store.get(matchingKey);

      return new Promise((resolve, reject) => {
        request.onsuccess = (event) => {
          const studentData = event.target.result;

          console.log('Raw Student Data:', studentData);

          // More robust nested structure checking
          if (!studentData || !studentData.result) {
            console.warn('No result data found for student');
            resolve(null);
            return;
          }

          const academicYearData = studentData.result[academicYear];
          if (!academicYearData) {
            console.warn(`No data found for academic year: ${academicYear}`);
            resolve(null);
            return;
          }

          const examData = academicYearData[examName];
          if (!examData) {
            console.warn(`No exam data found for: ${examName}`);
            resolve(null);
            return;
          }

          const result = {
            studentInfo: {
              name: studentData.stdName,
              surname: studentData.stdSurname,
              class: studentData.currentClass,
              rollNo: studentData.rollNo
            }
          };

          // Dynamically process subjects, including specialized structures
          Object.keys(examData).forEach((subject) => {
            // Skip 'remark' and other non-subject keys
            if (subject === 'remark') {
              result.remark = examData[subject];
              return;
            }

            // Explicitly handle 'nondi' key
            if (subject === 'nondi') {
              result.nondi = examData[subject];
              return;
            }

            // Handle different subject mark structures
            const subjectData = examData[subject];

            // Check for Akarik/Sanklik type structures (like in Physics, Maths)
            if (subjectData.Akarik || subjectData.Sanklik) {
              result[subject] = {
                Akarik: processSubjectSection(subjectData.Akarik),
                Sanklik: processSubjectSection(subjectData.Sanklik),
                Total: {
                  Akarik: subjectData.Akarik?.Total || 0,
                  Sanklik: subjectData.Sanklik?.Total || 0
                }
              };
            }
            // Standard subject mark structure
            else {
              result[subject] = {
                outOf: subjectData.outOf,
                obtainMarks: subjectData.obtainMarks,
                minMarks: subjectData.minMarks,
                writtenMarks: subjectData.writtenMarks,
                oralMarks: subjectData.oralMarks,
                subtype: subjectData.subtype,
                graceMarks: subjectData.graceMarks
              };
            }
          });

          console.log('Processed Marks:', result);
          resolve(result);
        };

        request.onerror = (event) => {
          console.error("Error fetching marks from IndexedDB:", event.target.error);
          reject(event.target.error);
        };
      });
    } catch (error) {
      console.error('Error in fetchMarksData:', error);
      return null;
    }
  };

  // Helper function to process Akarik/Sanklik subject sections
  function processSubjectSection(section) {
    if (!section) return {};

    return {
      Activity: section.Activity || 0,
      'Daily Monitoring': section['Daily Monitoring'] || 0,
      Demonstration: section.Demonstration || 0,
      Homework: section.Homework || 0,
      'Oral Work': section['Oral Work'] || 0,
      Others: section.Others || 0,
      Project: section.Project || 0,
      Test: section.Test || 0,
      Total: section.Total || 0,
      Orally: section.Orally || 0,
      Writing: section.Writing || 0
    };
  }

  const [selectedStudentForSr, setSelectedStudentForSr] = useState('')


  const fetchHeightWeightData = async (srNo, academicYear) => {
    try {
      const db = await openDB();
      const transaction = db.transaction(STUDENT_STORE, "readonly");
      const store = transaction.objectStore(STUDENT_STORE);

      const request = store.get(srNo); // Fetch student data by srNo

      return new Promise((resolve, reject) => {
        request.onsuccess = (event) => {
          const studentData = event.target.result;

          if (!studentData || !studentData.weightandHeight) {
            console.warn('No height and weight data found for student');
            resolve(null);
            return;
          }

          const heightWeight = studentData.weightandHeight[academicYear] || {};
          resolve(heightWeight);
        };

        request.onerror = (event) => {
          console.error("Error fetching height and weight from IndexedDB:", event.target.error);
          reject(event.target.error);
        };
      });
    } catch (error) {
      console.error('Error in fetchHeightWeightData:', error);
      return null;
    }
  };

  const viewResult = async (srNo) => {
    try {
      // Find the student in the selected students array
      const student = selectedStudents.find((student) => student.srNo === srNo);

      if (!student) {
        throw new Error("Student not found");
      }

      // Set the selected student
      setSelectedStudentForSr(student);

      // Fetch height and weight data
      const heightWeightData = await fetchHeightWeightData(student.id || srNo, academicYear);

      // Fetch First Semester marks
      const firstSemesterData = await fetchMarksData(
        student.id || srNo,
        academicYear,
        'First Semester'
      );

      // Fetch Selected Exam (Second Semester) marks
      const secondSemesterData = await fetchMarksData(
        student.id || srNo,
        academicYear,
        (selectedExamName === "All Exams" || selectedExamName === "Template") ? "Second Semester" : selectedExamName
      );

      // Validate data
      if (!firstSemesterData || !secondSemesterData) {
        setAlertMessage("Add the subject and fill the marks to view the result.");
        return;
      }

      const resultsWithTotal = {};

      // Combine all subjects from both semesters
      const allSubjects = new Set([
        ...Object.keys(firstSemesterData).filter(key => key !== 'studentInfo' && key !== 'remark' && key !== 'nondi'),
        ...Object.keys(secondSemesterData).filter(key => key !== 'studentInfo' && key !== 'remark' && key !== 'nondi')
      ]);

      allSubjects.forEach((subject) => {
        // First Semester Grade Calculation
        const firstSemesterAkarikTotal = firstSemesterData[subject]?.Akarik?.Total || 0;
        const firstSemesterSankalikTotal = firstSemesterData[subject]?.Sanklik?.Total || 0;
        const firstSemesterTotal = firstSemesterAkarikTotal + firstSemesterSankalikTotal;
        const firstSemesterGrade = calculateGrade(firstSemesterTotal);

        // Second Semester Grade Calculation
        const akarikTotal = secondSemesterData[subject]?.Akarik?.Total || 0;
        const sankalikTotal = secondSemesterData[subject]?.Sanklik?.Total || 0;
        const total = akarikTotal + sankalikTotal;
        const grade = calculateGrade(total);

        resultsWithTotal[subject] = {
          akarikTotal,
          sankalikTotal,
          total,
          grade,
          firstSemesterGrade,
        };
      });


      // Prepare height and weight data for display
      const heightSeptember = heightWeightData?.September ?? {};
      const heightMarch = heightWeightData?.March ?? {};

      // Extract nondi data
      const firstSemesterNondi = firstSemesterData.nondi || {};
      const secondSemesterNondi = secondSemesterData.nondi || {};

      // Set state with both semester data
      setSelectedStudentResults({
        studentName: student.stdName,
        results: resultsWithTotal,
        heightSeptember: heightSeptember.height || '',
        weightSeptember: heightSeptember.weight || '',
        heightMarch: heightMarch.height || '',
        weightMarch: heightMarch.weight || '',
        nondi: secondSemesterNondi, // Use second semester nondi as primary
        firstSemester: firstSemesterNondi,
        stdMother: student.stdMother,
        stdFather: student.stdFather,
        stdSurname: student.stdSurname,
        dob: student.dob,
        division: student.division,
        motherTounge: student.motherTounge,
        studentId: student.studentId,
        gender: student.gender,
        rollNo: student.rollNo,
      });

      setShowModal(true);
    } catch (error) {
      console.error("Error fetching student results:", error);
      setAlertMessage("Failed to fetch student results. Please try again.");
    }
  };




  const handleGradeChange = (subject, type, value) => {
    setSelectedStudentResults((prevState) => {
      const updatedResults = { ...prevState.results };
      updatedResults[subject][type] = parseInt(value, 10) || 0; // Ensure the value is a number

      return {
        ...prevState,
        results: updatedResults,
      };
    });
  };


  const calculateGradeEnglish = (total) => {
    if (total >= 91) return 'A1';
    if (total >= 81) return 'A2';
    if (total >= 71) return 'B1';
    if (total >= 61) return 'B2';
    if (total >= 51) return 'C1';
    if (total >= 41) return 'C2';
    if (total >= 33) return 'D';
    if (total >= 21) return 'E1';
    return 'E2';
  };

  const calculateGradeMarathi = (total) => {
    if (total >= 91) return 'à¤…-1';
    if (total >= 81) return 'à¤…-2';
    if (total >= 71) return 'à¤¬-1';
    if (total >= 61) return 'à¤¬-2';
    if (total >= 51) return 'à¤•-1';
    if (total >= 41) return 'à¤•-2';
    if (total >= 33) return 'à¤¡';
    if (total >= 21) return 'à¤ˆ-1';
    return 'à¤ˆ-2';
  };

  // Function to calculate grade based on the current language
  const calculateGrade = (total) => {
    return language === 'English' ? calculateGradeEnglish(total) : calculateGradeMarathi(total);
  };

  const submit = () => {
    // Handle submit logic here
  };
  const handleCloseModal = () => setShowModal(false);

  const months = ['Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May'];
  const [attendance, setAttendance] = useState({
    Present: {},
    Absent: {},
    Leave: {}
  });

  const fetchAttendanceFromIndexedDB = async (srNo, academicYear) => {
    try {
      console.log('Fetching Attendance Data with:', { srNo, academicYear });

      const db = await openDB();
      const transaction = db.transaction(ATTENDANCE_STORE, "readonly");
      const store = transaction.objectStore(ATTENDANCE_STORE);

      // Find all keys and log them
      const allKeys = await new Promise((resolve, reject) => {
        const keysRequest = store.getAllKeys();
        keysRequest.onsuccess = (event) => {
          const keys = event.target.result;
          console.log('ALL KEYS IN ATTENDANCE STORE:', keys);
          resolve(keys);
        };
        keysRequest.onerror = (event) => reject(event.target.error);
      });

      // Improved key matching with extensive logging
      const matchingKey = allKeys.find(storeKey => {
        const storeKeyStr = String(storeKey).trim();
        const srNoStr = String(srNo).trim();

        const isMatch = storeKeyStr === srNoStr;

        if (isMatch) {
          console.log('MATCHING KEY FOUND:', {
            storeKey,
            srNo,
            match: isMatch
          });
        }

        return isMatch;
      });


      console.log('Matching Attendance Key:', matchingKey);

      if (!matchingKey) {
        console.warn('No matching attendance key found for:', srNo);
        console.warn('Available keys:', allKeys);
        return null;
      }

      const request = store.get(matchingKey);

      return new Promise((resolve, reject) => {
        request.onsuccess = (event) => {
          const attendanceData = event.target.result;

          console.log('RAW ATTENDANCE DATA:', JSON.stringify(attendanceData, null, 2));

          // Extract the year from academic year
          const startYear = academicYear.split('-')[0];
          const endYear = academicYear.split('-')[1];

          // Process the attendance based on the months
          const fetchedAttendance = {
            Present: {},
            Absent: {},
            Leave: {}
          };

          // Define the first and second semester months
          const firstSemesterMonths = ['Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',];
          const secondSemesterMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May'];

          // Process each month
          [...firstSemesterMonths, ...secondSemesterMonths].forEach(month => {
            let yearForMonth = firstSemesterMonths.includes(month) ? startYear : endYear;

            // Get the attendance for the month
            const monthData = attendanceData.Presenty?.Presenty?.[yearForMonth]?.[month] || {};

            let presentCount = 0;
            let absentCount = 0;
            let leaveCount = 0;

            // Count attendance status for each day in the month
            Object.keys(monthData).forEach(day => {
              const statusObj = monthData[day];
              let status;

              if (statusObj && typeof statusObj === 'object') {
                status = statusObj.present || statusObj.status;
              } else {
                status = statusObj;
              }

              if (status === 'present' || status === true) {
                presentCount++;
              } else if (status === 'absent' || status === false) {
                absentCount++;
              } else if (status === null || status === undefined) {
                leaveCount++;
              }
            });

            // Store the counts in the fetched attendance data
            fetchedAttendance.Present[month] = presentCount;
            fetchedAttendance.Absent[month] = absentCount;
            fetchedAttendance.Leave[month] = leaveCount - 1;
          });

          console.log('PROCESSED ATTENDANCE:', fetchedAttendance);
          resolve(fetchedAttendance);
        };

        request.onerror = (event) => {
          console.error("Error fetching attendance from IndexedDB:", event.target.error);
          reject(event.target.error);
        };
      });
    } catch (error) {
      console.error('Error in fetchAttendanceFromIndexedDB:', error);
      return null;
    }
  };



  useEffect(() => {
    const fetchAttendanceData = async () => {
      console.log('FETCH ATTENDANCE EFFECT TRIGGERED');
      console.log('Selected Student:', selectedStudentForSr);
      console.log('Academic Year:', academicYear);

      if (!selectedStudentForSr) {
        console.warn('No student selected');
        return;
      }

      const srNo = selectedStudentForSr.serialNo;
      console.log('Student SR No:', srNo);
      const academicYearParts = academicYear.split('-');

      try {
        const attendanceData = await fetchAttendanceFromIndexedDB(srNo, academicYearParts[0] + '-' + academicYearParts[1]);

        if (attendanceData) {
          setAttendance(attendanceData);
          console.log('FINAL ATTENDANCE SET:', attendanceData);
        } else {
          console.warn('No attendance data found');
          setAttendance({
            Present: {},
            Absent: {},
            Leave: {}
          });
        }
      } catch (error) {
        console.error('Error fetching attendance data:', error);
        setAttendance({
          Present: {},
          Absent: {},
          Leave: {}
        });
      }
    };

    fetchAttendanceData();
  }, [selectedStudentForSr, academicYear]);


  const [summerVacationDate, setSummerVacationDate] = useState('');
  const [winterVacationDate, setWinterVacationDate] = useState('');

  // Define the English month names
  const firstSemesterMonths = ['Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov'];
  const secondSemesterMonths = ['Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May'];

  // Function to translate month to Marathi if needed
  const getMonthName = (month) => {
    const marathiMonths = {
      Jun: 'à¤œà¥‚à¤¨', Jul: 'à¤œà¥à¤²à¥ˆ', Aug: 'à¤‘à¤—à¤¸à¥à¤Ÿ', Sep: 'à¤¸à¤ªà¥à¤Ÿà¥‡à¤‚à¤¬à¤°', Oct: 'à¤‘à¤•à¥à¤Ÿà¥‹à¤¬à¤°', Nov: 'à¤¨à¥‹à¤µà¥à¤¹à¥‡à¤‚à¤¬à¤°',
      Dec: 'à¤¡à¤¿à¤¸à¥‡à¤‚à¤¬à¤°', Jan: 'à¤œà¤¾à¤¨à¥‡à¤µà¤¾à¤°à¥€', Feb: 'à¤«à¥‡à¤¬à¥à¤°à¥à¤µà¤¾à¤°à¥€', Mar: 'à¤®à¤¾à¤°à¥à¤š', Apr: 'à¤à¤ªà¥à¤°à¤¿à¤²', May: 'à¤®à¥‡', Total: 'à¤à¤•à¥‚à¤£'
    };
    return language === "English" ? month : marathiMonths[month];
  };

  const getAttendanceType = (type) => {
    const marathiTypes = {
      Present: 'à¤‰à¤ªà¤¸à¥à¤¥à¤¿à¤¤',
      Absent: 'à¤—à¥ˆà¤°à¤¹à¤œà¤°',
      Leave: 'à¤°à¤œà¤¾'
    };
    return language === "English" ? type : marathiTypes[type];
  };

  //  setting marks to pass 
  const getPassingMarks = (currentClass) => {
    if (selectedStudentForSr.currentClass === "Class V" || selectedStudentForSr.currentClass === "5th" || selectedStudentForSr.currentClass === "à¤‡à¤¯à¤¤à¥à¤¤à¤¾ à¤ªà¤¾à¤šà¤µà¥€") {
      return 18;
    } else if (selectedStudentForSr.currentClass === "Class VIII" || selectedStudentForSr.currentClass === "8th" || selectedStudentForSr.currentClass === "à¤‡à¤¯à¤¤à¥à¤¤à¤¾ à¤†à¤ à¤µà¥€") {
      return 21;
    }
    // Default passing marks if none of the specified classes are selected
    return 18;
  };

  const passingMarks = getPassingMarks(selectedStudentForSr.currentClass);

  //percentage 
  let totalSubjects = 0;
  let totalMarks = 0;
  let percentage = 0;

  if (selectedStudentResults && selectedStudentResults.results) {
    totalSubjects = Object.entries(selectedStudentResults.results)
      .filter(([subject]) => subject !== "nondi").length;

    totalMarks = Object.entries(selectedStudentResults.results)
      .filter(([subject]) => subject !== "nondi")
      .reduce((acc, [subject, grades]) => acc + (grades.sankalikTotal || 0) + (grades.akarikTotal || 0), 0);

    percentage = (totalMarks / (totalSubjects * 100)) * 100;
  }

  // Re-Exam
  const currentClass = selectedStudentResults?.currentClass; // Example: "Class V" or "Class VIII"
  const hasFailed = selectedStudentResults?.results &&
    Object.values(selectedStudentResults.results).some(grades => (grades.sankalikTotal || 0) + (grades.akarikTotal || 0) < passingMarks);

  // Add "Re-Exam" if the student is in Class V or VIII and has failed
  let examOptions = [...filteredExamNames];
  if ((currentClass === "Class V" || currentClass === "Class VIII") && hasFailed) {
    examOptions.push("Re-Exam");
  }

  const handleDivisionChange = (e) => {
    const selectedDivision = e.target.value;
    setDivision(selectedDivision); // Update division state

    let filteredStudents;

    if (selectedDivision === "") {
      // Show all students from the selected class if "All Student" is chosen
      filteredStudents = studentData.filter((student) => student.currentClass === classValue);
    } else {
      // Filter by class and division
      filteredStudents = studentData.filter(
        (student) => student.currentClass === classValue && student.division === selectedDivision
      );
    }

    setSelectedStudents(filteredStudents);
  };



  const handlePrint = () => {
    const printContent = document.querySelector('.modal-body'); // Select the modal body content

    if (printContent) {
      const printWindow = window.open('', '', 'height=600,width=800');
      printWindow.document.write(`
        <html>
          <head>
            <title>Print Student Report</title>
            <style>
             @page {
                size: ${selectedExamName === 'All Exams' ? 'A4 Portrait' : 'A4 Landscape'}; /* auto is the initial value */
              margin: 3mm; /* this affects the margin in the printer settings */
            }
              body {
                font-family: 'Poppins', sans-serif;
                margin: 0;
                padding: 0;
                color: black;
              }
  
              .container {
                width: 297mm;
                height: 200mm;
                margin: 0 auto;
                box-sizing: border-box;
                padding: 3mm;
                border: 3px solid #0e0303;
                overflow: hidden;
                display: flex;
                justify-content: space-between;
                margin-bottom: 20px;
              }
  .gradient-background {
  background: linear-gradient(to bottom, rgb(240, 217, 228), rgb(245, 255, 255), rgb(250, 230, 240));
}
              .left, .right {
                width: 48%;
                border: 2px solid black;
                padding: 10px;
                box-sizing: border-box;
              }
  .gradable{
  position: absolute; /* add this */
  bottom: 2px; /* add this */
  left: 1%; /* add this */
  width: 98%; /* add this */
}
           


.grad{
  position: absolute; /* add this */
  bottom: 0; /* add this */
  left: 20px; /* add this */
  width: 100%; /* add this */
}

.attendance-table th {
  font-weight: normal;
  font-size: 14px;
}

.attendance-table td:first-child {
  font-size: 12px;
  font-weight: normal;
}

  
              .left-box {
                background-color: #f9f9f9;
                padding: 20px;
                border: 1px solid #ddd;
                border-radius: 10px;
              }
  
              .school-info {
                display: flex;
                align-items: center;
                margin-bottom: 20px;
              }
  
              .school-info img {
                width: 100px;
                height: 100px;
                object-fit: cover;
                margin-right: 20px;
              }
  
              .school-info h2 {
                font-size: 18px;
                font-weight: bold;
                margin: 0;
              }
  
              .student-info {
                margin-top: 20px;
              }
  
              .student-info h3 {
                font-size: 16px;
                font-weight: bold;
                margin-bottom: 10px;
              }
  
              .student-info ul {
                list-style: none;
                padding: 0;
                margin: 0;
              }
  
              .student-info li {
                margin-bottom: 10px;
              }
  
              .student-info label {
                font-weight: bold;
                margin-right: 10px;
              }
  
              .student-info span {
                font-size: 14px;
                color: #666;
              }
  
              .student-info-grid {
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 20px;
                background-color: #f9f9f9;
                padding: 20px;
                border-radius: 10px;
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
              }
  
              .student-info-grid section {
                background-color: #ffffff;
                padding: 15px;
                border-radius: 8px;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
              }
  
              .student-info-grid h2 {
                font-size: 1em;
                margin-bottom: 10px;
                color: #333;
                border-bottom: 2px solid #ddd;
                padding-bottom: 5px;
              }
  
              .student-info-grid p {
                margin: 1px 0;
                font-size: 0.9em;
              }
  
              .student-info-grid label {
                font-weight: bold;
                color: #555;
              }
  
              .student-info-grid span {
                margin-left: 5px;
                color: #666;
              }
  
              .student-info-grid p:last-child {
                margin-bottom: 0;
              }
  
              .left {
                border: 2px solid #0f0202;
                padding: 20px;
                position: relative;
              }
  
              .right {
                position: relative;
                width: 48% !important;
                border: 2px solid #0e0101;
                padding: 10px;
                overflow: hidden;
              }
  
              /* Table styles */
              table {
                width: 100%;
                border-collapse: collapse;
                table-layout: fixed;
                border: 1px solid #130606;
              }
  
              th, td {
                border: 1px solid #130606;
                padding: 5px;
                text-align: left;
                word-wrap: break-word;
                box-sizing: border-box;
              }

               table th {
                border: 1px solid #130606;
              }

              .student-info-grid {
                border: 1px solid #130606;
              }

              .left-box  {
                border: 1px solid #130606;
              }
  
              .table-striped tbody tr:nth-of-type(odd) {
                background-color: rgba(0, 0, 0, 0.05); /* Stripe effect */
              }
  
              .table-bordered ,tr , th, td {
                border: 1px solid #130606;
              }

              .table-striped th ,td , tbody td {
              border: 1px solid #130606;
              }
  
             .grade-table {
  margin-top: 20px;
}

.grade-table table {
  width: 100%;
  border-collapse: collapse;
}

.grade-table th, .grade-table td {
                border: 1px solid #130606;
  padding: 5px;
  text-align: center;
  box-sizing: border-box;
}

.grade-table thead th {
  background-color: #f4f4f4;
}

.grade-table tbody td {
  text-align: center;
}
  
              .attendance-table th, .attendance-table td {
                width: 33%;
              }
                /* General Table Styles */
table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px; /* Adds space above the table */
}

thead {
  background-color: #f2f2f2; /* Light grey background for header */
}

th, td {
  border: 1px solid #ddd; /* Light grey border */
  padding: 8px; /* Space within cells */
  text-align: left; /* Align text to the left */
}

th {
  background-color: #f4f4f4; /* Slightly darker grey background for header cells */
  font-weight: bold; /* Bold text in header */
}

input[type="text"] {
  width: 100%; /* Full width of cell */
  box-sizing: border-box; /* Include padding and border in element's total width and height */
  border: 1px solid #ccc; /* Light grey border for input */
  padding: 4px; /* Space inside input field */
  font-size: 14px; /* Text size inside input */
}

input[type="text"]:focus {
  outline: none; /* Remove default focus outline */
  border-color: #007bff; /* Border color on focus */
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25); /* Shadow effect on focus */
}

/* Zebra striping for table rows */
tbody tr:nth-child(odd) {
  background-color: #fafafa; /* Light grey background for odd rows */

  }
  
              /* Ensure the right container does not overflow */
              .right {
                overflow: hidden; /* Clipping any content that exceeds the container bounds */
              }
            </style>
          </head>
          <body>
            ${printContent.innerHTML}
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
    } else {
      console.error('Print content not found');
    }
  };

  const englishSubjects = [
    { name: "Arts", akarikMarks: 100 },
    { name: "Work Experience", akarikMarks: 100 },
    { name: "Physical Education", akarikMarks: 100 },
    { name: "Computer", akarikMarks: 100 }, // New subject added
    { name: "computer", akarikMarks: 100 }, // New subject added
  ];

  const marathiSubjects = [
    { name: "à¤šà¤¿à¤¤à¥à¤°à¤•à¤²à¤¾", akarikMarks: 100 }, // New subject added
    { name: "à¤¶à¤¾à¤°à¥€à¤°à¤¿à¤• à¤¶à¤¿à¤•à¥à¤·à¤£", akarikMarks: 100 }, // New subject added
    { name: "à¤¸à¤‚à¤—à¤£à¤•", akarikMarks: 100 }, // New subject added
    { name: "à¤•à¤²à¤¾", akarikMarks: 100 },
    { name: "à¤•à¤¾à¤°à¥à¤¯à¤¾à¤¨à¥à¤­à¤µ", akarikMarks: 100 },
  ];
  return (
    <div>
      <AlertMessage message={alertMessage} show={showAlert} />

      {/* <Sidebar /> */}
      <div className=' main-content-of-page'>
        <h3 style={{ color: 'rgb(3, 54, 94)', textAlign: 'center' }}>  {language === "English" ? "Board Exam Result " : " à¤¬à¥‹à¤°à¥à¤¡ à¤ªà¤°à¥€à¤•à¥à¤·à¥‡à¤šà¤¾ à¤¨à¤¿à¤•à¤¾à¤²"}</h3>
        <table className="table table-striped table-bordered">
          <tbody>
            <tr>
              <th> {language === "English" ? "Academic Year " : "à¤¶à¥ˆà¤•à¥à¤·à¤£à¤¿à¤• à¤µà¤°à¥à¤·"}</th>
              <td>
                <select id="academicYear" value={academicYear} onChange={handleAcademicYearChange} className="form-control custom-select"
                >
                  <option >{language === "English" ? "Select Year " : "à¤µà¤°à¥à¤· à¤¨à¤¿à¤µà¤¡à¤¾"}</option>
                  <option value="2023-2024" >2023-2024</option>
                  <option value="2024-2025" >2024-2025</option>
                  <option value="2025-2026">2025-2026</option>
                  <option value="2026-2027">2026-2027</option>
                </select>
              </td>
            </tr>
            <tr>
              <th> {language === "English" ? "Class " : "à¤µà¤°à¥à¤—"}</th>
              <td>
                <select
                  id="class"
                  value={classValue}
                  onChange={handleClassChange}
                  className="form-control custom-select"
                  defaultValue={examNames[0]}
                >
                  <option value="">{language === "English" ? "Select Class " : "à¤µà¤°à¥à¤— à¤¨à¤¿à¤µà¤¡à¤¾"}</option>
                  {classes
                    .filter(cls => cls === 'Class V' || cls === 'Class VIII' || cls === '5th' || cls === '8th' || cls === 'à¤‡à¤¯à¤¤à¥à¤¤à¤¾ à¤ªà¤¾à¤šà¤µà¥€' || cls === 'à¤‡à¤¯à¤¤à¥à¤¤à¤¾ à¤†à¤ à¤µà¥€' || cls === 'à¤ªà¤¾à¤šà¤µà¥€' || cls === 'à¤†à¤ à¤µà¥€')
                    .map((cls, index) => (
                      <option key={index} value={cls}>
                        {cls}
                      </option>
                    ))}
                </select>
              </td>
            </tr>
            <tr>
              <th>{language === "English" ? "Division" : "à¤¤à¥à¤•à¤¡à¥€"}</th>
              <td>
                <select
                  value={division}
                  onChange={handleDivisionChange}
                  className="form-control custom-select"
                >
                  <option value="">
                    {language === "English" ? "All Student" : "à¤¸à¤°à¥à¤µ à¤µà¤¿à¤¦à¥à¤¯à¤¾à¤°à¥à¤¥à¥€"}
                  </option>
                  {divisions
                    .filter((div) => div !== null && div !== undefined && div.trim() !== "")
                    .map((div) => (
                      <option key={div} value={div}>
                        {div}
                      </option>
                    ))}
                </select>

              </td>
            </tr>
            <tr>
              <th>{language === "English" ? "Exam Name " : "à¤ªà¤°à¥€à¤•à¥à¤·à¥‡à¤šà¥‡ à¤¨à¤¾à¤µ"}</th>
              <td>
                <select
                  id="examName"
                  value={selectedExamName}
                  onChange={handleExamNameChange}
                  className="form-control custom-select"
                >
                  <option value="">{language === "English" ? "Select Exam " : "à¤ªà¤°à¥€à¤•à¥à¤·à¤¾ à¤¨à¤¿à¤µà¤¡à¤¾"}</option>
                  {examOptions.map((examName, index) => (
                    <option key={index} value={examName}>
                      {language === "English" ? examName : examNameTranslations[examName]}
                    </option>
                  ))}
                </select>

              </td>
            </tr>
          </tbody>
        </table>

        <Link to="/failed">
          {language === "English" ? (
            <button className="btn btn-primary">Go to Re-Exam Page</button>
          ) : (
            <button className="btn btn-primary">à¤ªà¥à¤¨à¤° à¤ªà¤°à¤¿à¤·à¤¾</button>
          )}
        </Link>
        {selectedStudents.length > 0 && (
          <div className="mt-4">
            <table className="table table-striped table-bordered custom-table">
              <thead>
                <tr>
                  <th className="custom-width">{language === "English" ? "Roll No " : "à¤¹à¤œà¤°à¥€ à¤•à¥à¤°"}</th>
                  <th>{language === "English" ? "Name " : "à¤¨à¤¾à¤µ"}</th>
                  <th>{language === "English" ? "Result " : "à¤ªà¥à¤°à¤—à¤¤à¥€à¤ªà¤¤à¥à¤°à¤•"}</th>
                </tr>
              </thead>
              <tbody>
                {selectedStudents
                  .sort((a, b) => a.rollNo - b.rollNo)
                  .map((student) => (
                    <tr key={student.srNo}>
                      <td>{student.rollNo}</td>
                      <td>{student.stdName} {student.stdFather} {student.stdSurname}</td>
                      <td>
                        <button className="btn btn-primary" onClick={() => viewResult(student.srNo)}>
                          {language === "English" ? "View Result" : "à¤ªà¥à¤°à¤—à¤¤à¤¿ à¤ªà¤¤à¥à¤°à¤•"}
                        </button>

                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}
        <Modal show={showModal} onHide={handleCloseModal} dialogClassName='modal-80w'>
          <Modal.Header closeButton>
            <Modal.Title>{language === "English" ? "Exam Result " : "à¤µà¤¿à¤¦à¥à¤¯à¤¾à¤°à¥à¤¥à¥à¤¯à¤¾à¤‚à¤šà¥‡ à¤¨à¤¿à¤•à¤¾à¤²"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>











            {selectedExamName === 'All Exams' && selectedStudentResults ? (
              <div style={{
                width: '210mm',
                minHeight: '297mm',
                padding: '15mm',
                background: 'linear-gradient(to bottom, rgb(240, 217, 228), rgb(245, 255, 255), rgb(250, 230, 240))',
                fontFamily: '"Nirmala UI", Arial, sans-serif',
                border: '12px double #2c3e50',
                margin: '20px auto',
                boxSizing: 'border-box',
                position: 'relative',
                color: '#000',
                boxShadow: '0 0 20px rgba(0,0,0,0.2)'
              }} className="board-result-container">
                {/* Header Section */}
                <div style={{ textAlign: 'center', position: 'relative', marginBottom: '20px' }}>
                  <p style={{ position: 'absolute', left: 0, top: 0, margin: 0, fontSize: '10px', fontWeight: 'bold' }}>
                    à¤¶à¤¾à¤¸à¤¨ à¤¨à¤¿à¤°à¥à¤£à¤¯ à¤•à¥à¤°à¤®à¤¾à¤‚à¤•: à¤†à¤°à¤Ÿà¥€à¤ˆ-à¥¨à¥¦à¥¨à¥¨/à¤ªà¥à¤°.à¤•à¥à¤°. à¥¨à¥­à¥¬/à¤à¤¸.à¤¡à¥€-à¥§
                  </p>
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '10px' }}>
                    {schoolLogo ? (
                      <img src={schoolLogo} alt="Logo" style={{ height: '50px', marginRight: '15px' }} />
                    ) : (
                      <div style={{ height: '50px', width: '50px', borderRadius: '50%', backgroundColor: '#ffd700', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '15px' }}>
                        <span style={{ fontSize: '20px' }}>ðŸª”</span>
                      </div>
                    )}
                  </div>
                  <h5 style={{ margin: '2px 0', color: '#2c3e50', fontWeight: 'bold' }}>à¤ªà¤°à¤¿à¤¶à¤¿à¤·à¥à¤Ÿ- à¥§</h5>
                  <h4 style={{ margin: '2px 0', color: '#d35400', fontWeight: 'bold', textTransform: 'uppercase' }}>à¤—à¥à¤£à¤ªà¤¤à¥à¤°à¤• à¤¨à¤®à¥à¤¨à¤¾ - à¤µà¤¾à¤°à¥à¤·à¤¿à¤• à¤ªà¤°à¥€à¤•à¥à¤·à¤¾ / à¤ªà¥à¤¨à¤°à¥à¤ªà¤°à¥€à¤•à¥à¤·à¤¾</h4>
                </div>

                {/* School & Student Info Section */}
                <div style={{ marginBottom: '15px', borderBottom: '1px solid #000', paddingBottom: '10px', fontSize: '13px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                    <div style={{ flex: 2 }}><strong>à¤¶à¤¾à¤³à¥‡à¤šà¥‡ à¤¨à¤¾à¤µ:</strong> {schoolName}</div>
                    <div style={{ flex: 1 }}><strong>à¤¶à¤¾à¤³à¤¾ UDISE:</strong> {udiseNumber}</div>
                    <div style={{ flex: 1 }}><strong>à¤¶à¥ˆà¤•à¥à¤·à¤£à¤¿à¤• à¤µà¤°à¥à¤·:</strong> {academicYear}</div>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ flex: 2 }}><strong>à¤µà¤¿à¤¦à¥à¤¯à¤¾à¤°à¥à¤¥à¥à¤¯à¤¾à¤‚à¤šà¥‡ à¤¨à¤¾à¤µ:</strong> {selectedStudentResults?.studentName}</div>
                    <div style={{ flex: 0.5 }}><strong>à¤¹à¤œà¥‡à¤°à¥€ à¤•à¥à¤°.:</strong> {selectedStudentResults?.rollNo}</div>
                    <div style={{ flex: 0.5 }}><strong>à¤¤à¥à¤•à¤¡à¥€:</strong> {selectedStudentResults?.division}</div>
                    <div style={{ flex: 1 }}><strong>à¤‡à¤¯à¤¤à¥à¤¤à¤¾:</strong> {classValue === 'Class V' ? 'à¥« à¤µà¥€' : 'à¥® à¤µà¥€'}</div>
                  </div>
                </div>

                {/* Marks Table */}
                <table style={{ width: '100%', borderCollapse: 'collapse', border: '1.5px solid #2c3e50', fontSize: '13px', backgroundColor: '#fff' }}>
                  <thead>
                    <tr style={{ backgroundColor: '#d1e7ff', color: '#003366' }}>
                      <th style={{ border: '1px solid #000', padding: '5px', width: '40px', textAlign: 'center' }}>à¤….à¤•à¥à¤°.</th>
                      <th style={{ border: '1px solid #000', padding: '5px', textAlign: 'center' }}>à¤µà¤¿à¤·à¤¯</th>
                      <th style={{ border: '1px solid #000', padding: '5px', width: '100px', textAlign: 'center' }}>à¤•à¤¿à¤®à¤¾à¤¨ à¤†à¤µà¤¶à¥à¤¯à¤• à¤—à¥à¤£</th>
                      <th style={{ border: '1px solid #000', padding: '5px', width: '120px', textAlign: 'center' }}>à¤à¤•à¥‚à¤£ à¤—à¥à¤£ à¥«à¥¦/à¥¬à¥¦ à¤ªà¥ˆà¤•à¥€</th>
                      <th style={{ border: '1px solid #000', padding: '5px', width: '120px', textAlign: 'center' }}>à¤¶à¥‡à¤°à¤¾ (à¤‰à¤¤à¥à¤¤à¥€à¤°à¥à¤£/à¤…à¤¨à¥à¤¤à¥à¤¤à¥€à¤°à¥à¤£)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {subjectSequence && subjectSequence.filter(s => s).map((subject, index) => {
                      const marks = selectedStudentResults.results[subject] || {};

                      // Check if it's an extra/grade-based subject (Art, PE, etc.)
                      const isExtraSubject = [...englishSubjects, ...marathiSubjects].some(
                        s => s?.name?.toLowerCase() === subject?.toLowerCase()
                      );

                      // For Board Results, show Sankalik (Summative) marks (out of 50/60)
                      const obtMarks = marks.sankalikTotal !== undefined ? marks.sankalikTotal : '-';
                      const isPass = marks.sankalikTotal >= (isExtraSubject ? 0 : passingMarks);

                      // Determine the remark/grade
                      const remark = isExtraSubject
                        ? (marks.grade || '-')
                        : (obtMarks === '-' ? '-' : (isPass ? 'à¤‰à¤¤à¥à¤¤à¥€à¤°à¥à¤£' : 'à¤…à¤¨à¥à¤¤à¥à¤¤à¥€à¤°à¥à¤£'));

                      return (
                        <tr key={index}>
                          <td style={{ border: '1px solid #000', padding: '5px', textAlign: 'center' }}>{index + 1}</td>
                          <td style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold' }}>{subject}</td>
                          <td style={{ border: '1px solid #000', padding: '5px', textAlign: 'center' }}>{isExtraSubject ? '-' : passingMarks}</td>
                          <td style={{ border: '1px solid #000', padding: '5px', textAlign: 'center' }}>{obtMarks}</td>
                          <td style={{ border: '1px solid #000', padding: '5px', textAlign: 'center' }}>
                            {isExtraSubject ? `à¤¶à¥à¤°à¥‡à¤£à¥€ - ${remark}` : remark}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                  <tfoot>
                    {(() => {
                      const academicResults = Object.keys(selectedStudentResults.results).filter(subj =>
                        !['Art', 'Work Experience', 'Physical Education', 'à¤•à¤²à¤¾', 'à¤•à¤¾à¤°à¥à¤¯à¤¾à¤¨à¥à¤­à¤µ', 'à¤¶à¤¾à¤°à¥€à¤°à¤¿à¤• à¤¶à¤¿à¤•à¥à¤·à¤£'].includes(subj)
                      );
                      const totalM = academicResults.reduce((sum, s) => sum + (selectedStudentResults.results[s]?.total || 0), 0);
                      const totalS = academicResults.length;
                      const perc = totalS > 0 ? (totalM / (totalS * 100)) * 100 : 0;

                      return (
                        <>
                          <tr>
                            <td colSpan="3" style={{ border: '1px solid #000', padding: '5px', textAlign: 'right' }}><strong>à¤¶à¥‡à¤•à¤¡à¤¾ à¤—à¥à¤£ :</strong></td>
                            <td colSpan="2" style={{ border: '1px solid #000', padding: '5px' }}><strong>{perc.toFixed(2)}%</strong></td>
                          </tr>
                          <tr>
                            <td colSpan="3" style={{ border: '1px solid #000', padding: '5px', textAlign: 'right' }}><strong>à¤¨à¤¿à¤•à¤¾à¤² à¤¦à¤¿à¤¨à¤¾à¤‚à¤• :</strong></td>
                            <td colSpan="2" style={{ border: '1px solid #000', padding: '5px' }}><strong>{new Date().toLocaleDateString('mr-IN')}</strong></td>
                          </tr>
                        </>
                      );
                    })()}
                  </tfoot>
                </table>

                {/* Footer Signatures - Updated */}
                <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'space-between', fontSize: '13px' }}>
                  <div style={{ textAlign: 'center' }}>
                    <div style={{ marginBottom: '30px' }}>..........................................</div>
                    <strong>{language === "English" ? "Class Teacher's Name & Signature" : "à¤µà¤°à¥à¤—à¤¶à¤¿à¤•à¥à¤·à¤•à¤¾à¤šà¥‡ à¤¨à¤¾à¤µ à¤µ à¤¸à¥à¤µà¤¾à¤•à¥à¤·à¤°à¥€"}</strong>
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <div style={{ marginBottom: '30px' }}>..........................................</div>
                    <strong>{language === "English" ? "Principal's Name & Signature" : "à¤®à¥à¤–à¥à¤¯à¤¾à¤§à¥à¤¯à¤¾à¤ªà¤•à¤¾à¤‚à¤šà¥‡ à¤¨à¤¾à¤µ à¤µ à¤¸à¥à¤µà¤¾à¤•à¥à¤·à¤°à¥€"}</strong>
                  </div>
                </div>

                <div style={{ textAlign: 'center', marginTop: '20px', borderTop: '1px solid #eee', paddingTop: '5px' }}>
                  <p style={{ margin: 0, fontStyle: 'italic', fontSize: '12px' }}>à¤¶à¤¾à¤³à¥‡à¤šà¤¾ à¤¶à¤¿à¤•à¥à¤•à¤¾</p>
                </div>
              </div>
            ) : (

              <div>
                {/* Second semester modal content */}

                <div className="container  " style={{
                  background: `linear-gradient(to bottom, rgb(240, 217, 228), rgb(245, 255, 255), rgb(250, 230, 240))`
                }} >
                  <div className="left">

                    {/* First Semester Attendance Table */}
                    <h3>{language === "English" ? "Attendance:" : "à¤¹à¤œà¥‡à¤°à¥€"}</h3>
                    <table className="attendance-table" style={{ marginBottom: '15px' }}>
                      <thead>
                        <tr>
                          <th>{language === "English" ? "Type:" : "à¤ªà¥à¤°à¤•à¤¾à¤°"}</th>
                          {firstSemesterMonths.map((month, index) => (
                            <th key={index}>{getMonthName(month)}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {['Present', 'Absent'].map((type) => (
                          <tr key={type}>
                            <td>{type === 'Present' ? (language === 'English' ? 'Present Days' : 'à¤¹à¤œà¤° à¤¦à¤¿à¤µà¤¸') : (language === 'English' ? 'Working Days' : 'à¤•à¤¾à¤®à¤¾à¤šà¥‡ à¤¦à¤¿à¤µà¤¸')}</td>
                            {firstSemesterMonths.map((month, index) => (
                              <td key={index}>
                                <input
                                  type="text"
                                  value={attendance[type][month] || ''}
                                // onChange={(e) => handleInputChange(type, month, e.target.value)}
                                />
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>

                    {/* Second Semester Attendance Table */}
                    <table className="attendance-table">
                      <thead>
                        <tr>
                          <th>{language === "English" ? "Type:" : "à¤ªà¥à¤°à¤•à¤¾à¤°"}</th>
                          {['Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'Total'].map((month, index) => (
                            <th key={index}>{getMonthName(month)}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {['Present', 'Absent'].map((type) => (
                          <tr key={type}>
                            <td>{type === 'Present' ? (language === 'English' ? 'Present Days' : 'à¤¹à¤œà¤° à¤¦à¤¿à¤µà¤¸') : (language === 'English' ? 'Working Days' : 'à¤•à¤¾à¤®à¤¾à¤šà¥‡ à¤¦à¤¿à¤µà¤¸')}</td>
                            {['Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'Total'].map((month, index) => {
                              let cellVal = '';
                              if (month === 'Total') {
                                let sum = 0;
                                let hasAny = false;
                                ['Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr'].forEach(m => {
                                  const v = attendance?.[type]?.[m];
                                  if (v !== undefined && v !== null && v !== '' && !isNaN(Number(v))) {
                                    sum += Number(v);
                                    hasAny = true;
                                  }
                                });
                                cellVal = hasAny ? sum : '';
                              } else {
                                cellVal = attendance[type][month] || '';
                              }
                              return (
                                <td key={index}>
                                  <input
                                    type="text"
                                    value={cellVal}
                                    readOnly={month === 'Total'}
                                  />
                                </td>
                              );
                            })}
                          </tr>
                        ))}
                      </tbody>
                    </table>

                    <div style={{ marginTop: '15px' }}>
                      <p style={{ margin: '5px 0', fontWeight: 'bold' }}>{language === 'English' ? 'The school will reopen on' : 'à¤¶à¤¾à¤³à¤¾ à¤ªà¥à¤¨à¥à¤¹à¤¾ à¤¸à¥à¤°à¥‚ à¤¹à¥‹à¤£à¥à¤¯à¤¾à¤šà¥€ à¤¤à¤¾à¤°à¥€à¤– :'}</p>
                      <p style={{ margin: '10px 0 20px 0', fontWeight: 'bold', fontSize: '13px' }}>
                        {language === 'English' ? 'Date: _________ at _________ am/pm' : 'à¤¦à¤¿à¤¨à¤¾à¤‚à¤•: _________ à¤µà¥‡à¤³ _________'}
                      </p>
                      
                      {/* Updated Class Teacher Signature */}
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '30px', paddingRight: '20px' }}>
                        <strong>{language === 'English' ? "Class Teacher's Signature" : 'à¤µà¤°à¥à¤—à¤¶à¤¿à¤•à¥à¤·à¤•à¤¾à¤šà¥€ à¤¸à¤¹à¥€'}</strong>
                        <strong>{language === 'English' ? "Parent's Signature" : 'à¤ªà¤¾à¤²à¤•à¤¾à¤‚à¤šà¥€ à¤¸à¤¹à¥€'}</strong>
                      </div>
                    </div>

                    {/* Updated Instructions for parents - Removed first line */}
                    <div style={{ marginTop: '40px' }}>
                      <p style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '15px' }}>{language === 'English' ? 'Instructions for parents:' : 'à¤ªà¤¾à¤²à¤•à¤¾à¤‚à¤¸à¤¾à¤ à¥€ à¤¸à¥‚à¤šà¤¨à¤¾:'}</p>
                      <ol style={{ paddingLeft: '20px', margin: 0, fontSize: '13px', lineHeight: '1.6' }}>
                        <li>{language === 'English' ? 'Promotions are strictly made following the rules laid by the department of education.' : 'à¤¶à¤¿à¤•à¥à¤·à¤£ à¤µà¤¿à¤­à¤¾à¤—à¤¾à¤šà¥à¤¯à¤¾ à¤¨à¤¿à¤¯à¤®à¤¾à¤‚à¤¨à¥à¤¸à¤¾à¤°à¤š à¤ªà¥à¤¢à¥€à¤² à¤µà¤°à¥à¤—à¤¾à¤¤ à¤ªà¤¦à¥‹à¤¨à¥à¤¨à¤¤à¥€ à¤¦à¤¿à¤²à¥€ à¤œà¤¾à¤ˆà¤².'}</li>
                        <li>{language === 'English' ? 'Result will not be declared, unless & until school fees dues are paid.' : 'à¤¶à¤¾à¤³à¥‡à¤šà¥€ à¤¸à¤‚à¤ªà¥‚à¤°à¥à¤£ à¤«à¥€ à¤­à¤°à¤²à¥à¤¯à¤¾à¤¶à¤¿à¤µà¤¾à¤¯ à¤¨à¤¿à¤•à¤¾à¤² à¤œà¤¾à¤¹à¥€à¤° à¤•à¥‡à¤²à¤¾ à¤œà¤¾à¤£à¤¾à¤° à¤¨à¤¾à¤¹à¥€.'}</li>
                      </ol>
                    </div>

                  </div>
                  <div className="right">

                    <div className="left-box" style={{ border: '1px solid black', padding: '10px' }}>
                      <div className="school-info" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', justifyContent: 'center' }}>
                        <h2 style={{ fontSize: '20px', fontWeight: 'bold', margin: '5px 0' }}>{schoolName}</h2>
                        {schoolLogo && (
                          <div style={{ margin: '5px 0' }}>
                            <img src={schoolLogo} alt="Logo" style={{ width: '80px', height: '80px', objectFit: 'contain', margin: '0' }} />
                          </div>
                        )}
                        <h3 style={{ margin: '5px 0', fontSize: '18px', fontWeight: 'bold' }}>
                          {language === "English" ? "PROGRESS CARD" : "à¤ªà¥à¤°à¤—à¤¤à¥€ à¤ªà¤¤à¥à¤°à¤•"}
                        </h3>
                        <p style={{ margin: '0', fontSize: '14px', fontWeight: 'bold' }}>
                          {language === "English" ? "Year -" : "à¤µà¤°à¥à¤· -"} {academicYear}
                        </p>
                      </div>
                    </div>
                    <br />

                    <div className="student-info-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', border: '1px solid black', padding: '15px' }}>
                      <p style={{ gridColumn: 'span 2' }}>
                        <label>{language === "English" ? "Name :" : "à¤¨à¤¾à¤µ :"}</label>
                        <span>
                          {selectedStudentResults?.studentName || ''}{' '}
                          {selectedStudentResults?.stdFather || ''}{' '}
                          {selectedStudentResults?.stdSurname || ''}
                        </span>
                      </p>
                      <p>
                        <label>{language === "English" ? "Std. :" : "à¤‡à¤¯à¤¤à¥à¤¤à¤¾ :"}</label>
                        <span>{classValue ? classValue.replace("Class ", "") : '-'}</span>
                      </p>
                      <p>
                        <label>{language === "English" ? "Div. :" : "à¤¤à¥à¤•à¤¡à¥€ :"}</label>
                        <span>{selectedStudentResults?.division || '-'}</span>
                      </p>
                      <p>
                        <label>{language === "English" ? "Roll No. :" : "à¤¹à¤œà¥‡à¤°à¥€ à¤•à¥à¤°. :"}</label>
                        <span>{selectedStudentResults?.rollNo || '-'}</span>
                      </p>
                      <p>
                        <label>{language === "English" ? "Blood Gr. :" : "à¤°à¤•à¥à¤¤à¤—à¤Ÿ :"}</label>
                        <span>{selectedStudentResults?.bloodGroup || '-'}</span>
                      </p>
                      <p>
                        <label>{language === "English" ? "UDISE No. :" : "à¤¯à¥‚-à¤¡à¤¾à¤¯à¤¸ à¤•à¥à¤°. :"}</label>
                        <span>{udiseNumber || '-'}</span>
                      </p>
                      <p>
                        <label>{language === "English" ? "Gen. Regd. No. :" : "à¤¨à¥‹à¤‚à¤¦à¤£à¥€ à¤•à¥à¤°. :"}</label>
                        <span>{selectedStudentResults?.registerNo || '-'}</span>
                      </p>
                      <p>
                        <label>{language === "English" ? "Aadhaar No. :" : "à¤†à¤§à¤¾à¤° à¤•à¥à¤°. :"}</label>
                        <span>{selectedStudentResults?.stdAdharNo || '-'}</span>
                      </p>
                      <p>
                        <label>{language === "English" ? "DOB :" : "à¤œà¤¨à¥à¤®à¤¤à¤¾à¤°à¥€à¤– :"}</label>
                        <span>{selectedStudentResults?.dob ? selectedStudentResults.dob.split('-').reverse().join('-') : '-'}</span>
                      </p>
                      <p>
                        <label>{language === "English" ? "PEN No. :" : "à¤ªà¥‡à¤¨ à¤•à¥à¤°. :"}</label>
                        <span>{selectedStudentResults?.aparId || '-'}</span>
                      </p>
                      <p>
                        <label>{language === "English" ? "APAR No. ID :" : "à¤…à¤ªà¤¾à¤° à¤†à¤¯à¤¡à¥€ :"}</label>
                        <span>{selectedStudentResults?.aparId || '-'}</span>
                      </p>
                      <p>
                        <label>{language === "English" ? "Mobile No. :" : "à¤®à¥‹à¤¬à¤¾à¤ˆà¤² à¤•à¥à¤°. :"}</label>
                        <span>{selectedStudentResults?.mobileNo || '-'}</span>
                      </p>
                      <p>
                        <label>{language === "English" ? "Mothers Name :" : "à¤†à¤ˆà¤šà¥‡ à¤¨à¤¾à¤µ :"}</label>
                        <span>{selectedStudentResults?.stdMother || '-'}</span>
                      </p>
                      <p>
                        <label>{language === "English" ? "Weight (kg) :" : "à¤µà¤œà¤¨ (à¤•à¤¿à¤—à¥à¤°à¥…) :"}</label>
                        <span>{selectedStudentResults?.weightSeptember || selectedStudentResults?.weightMarch || '-'}</span>
                      </p>
                      <p>
                        <label>{language === "English" ? "Height (cm) :" : "à¤‰à¤‚à¤šà¥€ (à¤¸à¥‡à¤®à¥€) :"}</label>
                        <span>{selectedStudentResults?.heightSeptember || selectedStudentResults?.heightMarch || '-'}</span>
                      </p>
                      <p style={{ gridColumn: 'span 2' }}>
                        <label>{language === "English" ? "Address :" : "à¤ªà¤¤à¥à¤¤à¤¾ :"}</label>
                        <span>{selectedStudentResults?.address || '-'}</span>
                      </p>
                    </div>

                  </div>
                </div>

                <div className="container mt-1" style={{ background: `linear-gradient(to bottom, rgb(240, 217, 228), rgb(245, 255, 255), rgb(250, 230, 240))` }}>
                  <div className="left"   >
                    <h3>{language === "English" ? "Student Progress Card " : "à¤µà¤¿à¤¦à¥à¤¯à¤¾à¤°à¥à¤¥à¥€ à¤ªà¥à¤°à¤—à¤¤à¥€ à¤…à¤¹à¤µà¤¾à¤²"}</h3>
                    <div>
                      <label htmlFor="roll-no">{language === "English" ? "Roll No: " : "à¤¹à¤œà¥‡à¤°à¥€ à¤•à¥à¤°à¤®à¤¾à¤‚à¤•: "}</label>
                      <span>{selectedStudentResults?.rollNo || 'N/A'}</span>
                    </div>
                    <div>
                      <label htmlFor="student-name">{language === "English" ? "Student Name: " : "à¤µà¤¿à¤¦à¥à¤¯à¤¾à¤°à¥à¤¥à¥à¤¯à¤¾à¤šà¥‡ à¤¨à¤¾à¤µ: "}</label>
                        <span>{selectedStudentResults?.studentName || 'N/A'}</span>
                    </div>
                    <div>
                      <label htmlFor="class">{language === "English" ? "Std.: " : "à¤µà¤°à¥à¤—: "}</label>
                      <span style={{ marginRight: '20px' }}>{classValue ? classValue.replace("Class ", "") : 'N/A'}</span>
                      <label htmlFor="division">{language === "English" ? "Div.: " : "à¤¤à¥à¤•à¤¡à¥€: "}</label>
                      <span>{selectedStudentResults?.division || '-'}</span>
                    </div>

                    <div>
                      <label htmlFor="exam-roll-no">{language === "English" ? (selectedExamName === "Template" ? "Class Teacher: " : "Exam: ") : (selectedExamName === "Template" ? "à¤µà¤°à¥à¤—à¤¶à¤¿à¤•à¥à¤·à¤•: " : "à¤ªà¤°à¥€à¤•à¥à¤·à¤¾ à¤¸à¤¤à¥à¤°: ")}</label>
                      <span>{selectedExamName === "Template" ? (selectedStudentResults?.classTeacher || '') : (selectedExamName || 'N/A')}</span>
                    </div>

                    {selectedStudentResults?.results ? (
                      <table className="table table-striped table-bordered">
                        <thead>
                          <tr>
                            <th rowSpan='2'>{language === "English" ? "Subject" : "à¤µà¤¿à¤·à¤¯"}</th>
                            {selectedExamName !== "Template" && (
                              <th colSpan="1">{language === "English" ? "First Sem" : "à¤ªà¥à¤°à¤¥à¤® à¤¸à¤¤à¥à¤°"}</th>
                            )}
                            <th colSpan="3">{language === "English" ? (selectedExamName === "Template" ? "Final Exam" : "Second Sem") : (selectedExamName === "Template" ? "à¤…à¤‚à¤¤à¤¿à¤® à¤ªà¤°à¥€à¤•à¥à¤·à¤¾" : "à¤¦à¥à¤µà¤¿à¤¤à¥€à¤¯ à¤¸à¤¤à¥à¤°")}</th>
                          </tr>
                          <tr>
                            {selectedExamName !== "Template" && (
                                <th>{language === "English" ? "Grade" : "श्रेणी"}</th>
                              )}
                              <th>{language === "English" ? "Min.M" : "किमान गुण"}</th>
                              <th>{language === "English" ? (selectedExamName === "Template" ? (classValue?.includes("VIII") ? "Written (60)" : "Written (50)") : "Obt.M") : (selectedExamName === "Template" ? (classValue?.includes("VIII") ? "लेखी (60)" : "लेखी (50)") : "प्राप्त गुण")}</th>
                              <th>{language === "English" ? (selectedExamName === "Template" ? "(Pass / Fail )" : "Remark") : (selectedExamName === "Template" ? "(उत्तीर्ण / अनुत्तीर्ण)" : "शेरा")}</th>
                          </tr>
                        </thead>
                        <tbody>

                          {selectedStudentResults && selectedStudentResults.results ? (
                            (selectedExamName === "Template" 
                              ? (classValue?.includes("VIII") 
                                  ? [
                                      Object.keys(selectedStudentResults.results || {}).find(k => k.includes("English")) || 'English',
                                      Object.keys(selectedStudentResults.results || {}).find(k => k.includes("Marathi")) || 'Marathi',
                                      Object.keys(selectedStudentResults.results || {}).find(k => k.includes("Sanskrit")) || 'Sanskrit',
                                      Object.keys(selectedStudentResults.results || {}).find(k => k.includes("Hindi")) || 'Hindi',
                                      Object.keys(selectedStudentResults.results || {}).find(k => k.includes("Math")) || 'Mathematics',
                                      Object.keys(selectedStudentResults.results || {}).find(k => k.includes("History")) || 'History-Civics'
                                    ] 
                                  : ['English', 'Marathi', 'Hindi']) 
                              : [
                                  ...subjectSequence,
                                  ...Object.keys(selectedStudentResults.results).filter((subject) => !subjectSequence.includes(subject))
                                ]
                                .filter(Boolean)
                                .filter(subject => !['Maths', 'Mathematics', 'Math', 'à¤—à¤£à¤¿à¤¤'].includes(subject))
                            ).map((subject) => {
                                const grades = selectedStudentResults.results[subject] || {};
                                const isExtraSubject = [...englishSubjects, ...marathiSubjects].some(
                                  s => s?.name?.toLowerCase() === subject?.toLowerCase()
                                );

                                // Map subject names for Class VIII
                                let displaySubject = subject;
                                                                if (classValue?.includes("VIII")) {
                                  if (subject?.includes("Sanskrit")) displaySubject = "Sanskrit + Hindi";
                                  else if (subject?.includes("Hindi")) displaySubject = "G. Science";
                                  else if (subject?.includes("History")) displaySubject = "Social Science";
                                }

                                // If it's an extra subject, calculate grade using only Akarik total
                                const remark = isExtraSubject
                                  ? calculateGrade(grades.akarikTotal || 0)
                                  : grades.sankalikTotal === undefined 
                                    ? '-' 
                                    : grades.sankalikTotal >= passingMarks
                                      ? language === "English" ? "Pass" : "à¤‰à¤¤à¥à¤¤à¥€à¤°à¥à¤£"
                                      : language === "English" ? "Fail" : "à¤…à¤¨à¥à¤¤à¥à¤¤à¥€à¤°à¥à¤£";

                                return (
                                  <tr key={subject}>
                                    <td><b>{displaySubject}</b></td>
                                    {selectedExamName !== "Template" && (
                                      <td><b>{grades.firstSemesterGrade || '-'}</b></td>
                                    )}
                                    <td><b>{passingMarks || 'N/A'}</b></td>
                                    <td><b>{grades.sankalikTotal || '-'}</b></td>
                                    <td><b>{remark}</b></td>
                                  </tr>
                                );
                              })
                          ) : (
                            <tr>
                              <td colSpan="5">{language === "English" ? "No data available" : "à¤¡à¥‡à¤Ÿà¤¾ à¤‰à¤ªà¤²à¤¬à¥à¤§ à¤¨à¤¾à¤¹à¥€"}</td>
                            </tr>
                          )}

                          {selectedStudentResults && selectedStudentResults.results && (
                            <>
                              <tr>
                                {selectedExamName !== "Template" && (
                                  <td colSpan="1"></td>
                                )}
                                <td colSpan="2"><b>{language === "English" ? "Total Marks" : "à¤à¤•à¥‚à¤£ à¤—à¥à¤£"}</b></td>
                                <td colSpan="1"><b>{totalMarks} / {totalSubjects * 100}</b></td>
                                <td colSpan="1"><b>{selectedExamName === "Template" ? "" : percentage.toFixed(2) + "%"}</b></td>
                              </tr>
                            </>
                          )}
                        </tbody>
                      </table>
                    ) : (
                      <p>{language === "English" ? "No results available. " : "à¤•à¥‹à¤£à¤¤à¥‡à¤¹à¥€ à¤ªà¥à¤°à¤—à¤¤à¥€à¤ªà¤¤à¥à¤°à¤• à¤‰à¤ªà¤²à¤¬à¥à¤§ à¤¨à¤¾à¤¹à¥€à¤¤."}</p>
                    )}

                    {/* Updated Signatures */}
                                          <div className="grad" style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', marginTop: '60px', padding: '0 10px', width: '100%', gap: '15px' }}>
                        <label htmlFor="class-teacher" style={{ textAlign: 'center' }}>
                          {language === "English" ? "Class Teacher's Signature" : "वर्गशिक्षकाची सही"}
                        </label>
                        <label htmlFor="moderator" style={{ textAlign: 'center' }}>
                          {language === "English" ? "Moderator" : "मॉडरेटर"}
                        </label>
                        <label htmlFor="incharge" style={{ textAlign: 'center' }}>
                          {language === "English" ? "Incharge" : "इंचार्ज"}
                        </label>
                        <label htmlFor="principal" style={{ textAlign: 'center' }}>
                          {language === "English" ? "Principal's Signature" : "मुख्याध्यापकांची सही"}
                        </label>
                      </div>
                  </div>
                  <div className="right">
                    {selectedExamName === "Template" ? (
                      <>
                        <h3 style={{ textAlign: "center", color: "black", fontFamily: "Arial, sans-serif", fontWeight: "bold", marginBottom: "20px" }}>
                          {language === "English" ? "Remark " : "à¤¶à¥‡à¤°à¤¾"}
                        </h3>
                        <div style={{ marginTop: '15px', fontSize: '14px', lineHeight: '1.8', fontWeight: '600' }}>
                          <div>Result-passed and promoted to std {classValue === 'Class V' ? 'Class VI' : (classValue === 'Class VIII' ? 'Class IX' : '')} /</div>
                          <div>failed and eligible for re-exam / failed in re-exam & detained in std {classValue ? classValue.replace("Class ", "") : ''}</div>
                        </div>
                      </>
                    ) : (
                      <>
                        <h3 style={{ textAlign: "center", color: "black", fontFamily: "Arial, sans-serif", fontWeight: "bold", marginBottom: "20px" }}>
                          {language === "English" ? "Nondi " : "à¤¨à¥‹à¤‚à¤¦à¥€"}
                        </h3>

                        <table style={{ width: "100%", borderCollapse: "collapse", fontFamily: "Arial, sans-serif" }}>

                          <thead>
                            <tr style={{ color: "black", textAlign: "center" }}>
                              <th colSpan="" style={{ padding: "2px", border: "1px solid #ddd", fontSize: "16px" }}>{language === "English" ? "First Term " : "à¤ªà¥à¤°à¤¥à¤® à¤¸à¤¤à¥à¤°"} </th>
                              <th colSpan="" style={{ padding: "2px", border: "1px solid #ddd", fontSize: "16px" }}>{language === "English" ? "Second Term " : "à¤¦à¥à¤µà¤¿à¤¤à¥€à¤¯ à¤¸à¤¤à¥à¤°"} </th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr style={{ color: "black", textAlign: "center" }}>
                              <th colSpan="2" style={{ padding: "2px", border: "1px solid #ddd", fontSize: "16px" }}>{language === "English" ? "Special Progress" : "à¤µà¤¿à¤¶à¥‡à¤· à¤ªà¥à¤°à¤—à¤¤à¥€"}</th>

                            </tr>
                            <tr style={{ backgroundColor: "#ffffff" }}>
                              <td style={{ width: "50%", padding: "2px", border: "1px solid #ddd", verticalAlign: "top" }}>
                                <textarea
                                  id="special-progress"
                                  style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "4px",
                                    border: "1px solid #ccc",
                                    boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
                                    resize: "none",
                                    fontSize: "14px",
                                    height: "100px"
                                  }}
                                  value={selectedStudentResults?.firstSemester?.specialEntries || "No data available"}
                                  readOnly
                                />
                              </td>

                              <td style={{ width: "50%", padding: "2px", border: "1px solid #ddd", verticalAlign: "top" }}>
                                <textarea
                                  id="special-progress"
                                  style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "4px",
                                    border: "1px solid #ccc",
                                    boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
                                    resize: "none",
                                    fontSize: "14px",
                                    height: "100px"
                                  }}
                                  value={selectedStudentResults?.nondi?.specialEntries || "No data available"}
                                  readOnly
                                />
                              </td>
                            </tr>
                            <tr style={{ color: "black", textAlign: "center" }}>
                              <th colSpan="2" style={{ padding: "2px", border: "1px solid #ddd", fontSize: "16px" }}>{language === "English" ? "Hobbies" : "à¤›à¤‚à¤¦"}</th>
                            </tr>
                            <tr style={{ backgroundColor: "#ffffff" }}>
                              <td style={{ width: "33%", padding: "2px", border: "1px solid #ddd", verticalAlign: "top" }}>
                                <textarea
                                  id="special-progress"
                                  style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "4px",
                                    border: "1px solid #ccc",
                                    boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
                                    resize: "none",
                                    fontSize: "14px",
                                    height: "100px"
                                  }}
                                  value={selectedStudentResults?.firstSemester?.interestsAndHobbies || "No data available"}
                                  readOnly />
                              </td>
                              <td style={{ padding: "2px", border: "1px solid #ddd", verticalAlign: "top" }}>
                                <textarea
                                  id="hobbies"
                                  style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "4px",
                                    border: "1px solid #ccc",
                                    boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
                                    resize: "none",
                                    fontSize: "14px",
                                    height: "100px"
                                  }}
                                  value={selectedStudentResults?.nondi?.interestsAndHobbies || "No data available"}
                                  readOnly
                                />
                              </td>

                            </tr>
                            <tr style={{ color: "black", textAlign: "center" }}>
                              <th colSpan="2" style={{ padding: "2px", border: "1px solid #ddd", fontSize: "16px" }}>{language === "English" ? "Required Improvements" : "à¤†à¤µà¤¶à¥à¤¯à¤• à¤¸à¥à¤§à¤¾à¤°à¤£à¤¾"}</th>
                            </tr>
                            <tr style={{ backgroundColor: "#ffffff" }}>
                              <td style={{ width: "33%", padding: "2px", border: "1px solid #ddd", verticalAlign: "top" }}>
                                <textarea
                                  id="special-progress"
                                  style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "4px",
                                    border: "1px solid #ccc",
                                    boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
                                    resize: "none",
                                    fontSize: "14px",
                                    height: "100px"
                                  }}
                                  value={selectedStudentResults?.firstSemester?.necessaryCorrections || "No data available"}
                                  readonly />
                              </td>
                              <td style={{ padding: "2px", border: "1px solid #ddd", verticalAlign: "top" }}>
                                <textarea
                                  id="improvements"
                                  style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "4px",
                                    border: "1px solid #ccc",
                                    boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
                                    resize: "none",
                                    fontSize: "14px",
                                    height: "100px"
                                  }}
                                  value={selectedStudentResults?.nondi?.necessaryCorrections || "No data available"}
                                  readOnly
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                                                {classValue?.includes("VIII") ? (
                          <div style={{ marginTop: '30px', padding: '15px', border: '2px solid black' }}>
                            <div style={{ fontSize: '14px', lineHeight: '2.0', fontWeight: 'bold', fontFamily: 'Arial, sans-serif' }}>
                              <div>Result-passed and promoted to std Class IX /</div>
                              <div>failed and eligible for re-exam. / failed in re-exam &</div>
                              <div>detained in std - VIII</div>
                            </div>
                            <div style={{ marginTop: '20px' }}>
                              <p style={{ margin: '5px 0', fontWeight: 'bold', fontSize: '13px', fontFamily: 'Arial, sans-serif' }}>The school will Re-open on --- June 2025 -at 7.15 am</p>
                            </div>
                          </div>
                        ) : (
                          <div className="grade-table" >
                          <h3>{language === "English" ? "Grade Table" : "à¤¶à¥à¤°à¥‡à¤£à¥€ à¤Ÿà¥‡à¤¬à¤²"}</h3>
                          <table >
                            <thead>
                              <tr>
                                <th>{language === "English" ? "A1" : "à¤…1"}</th>
                                <th>{language === "English" ? "A2" : "à¤…2"}</th>
                                <th>{language === "English" ? "B1" : "à¤¬1"}</th>
                                <th>{language === "English" ? "B2" : "à¤¬2"}</th>
                                <th>{language === "English" ? "C1" : "à¤•1"}</th>
                                <th>{language === "English" ? "C2" : "à¤•2"}</th>
                                <th>{language === "English" ? "D" : "à¤¡"}</th>
                                <th>{language === "English" ? "E1" : "à¤ˆ1"}</th>
                                <th>{language === "English" ? "E2" : "à¤ˆ2"}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>91% à¤¤à¥‡ 100%</td>
                                <td>81% à¤¤à¥‡ 90%</td>
                                <td>71% à¤¤à¥‡ 80%</td>
                                <td>61% à¤¤à¥‡ 70%</td>
                                <td>51% à¤¤à¥‡ 60%</td>
                                <td>41% à¤¤à¥‡ 50%</td>
                                <td>33% à¤¤à¥‡ 40%</td>
                                <td>21% à¤¤à¥‡ 32%</td>
                                <td>20% à¤ªà¥‡à¤•à¥à¤·à¤¾ à¤•à¤®à¥€</td>
                              </tr>
                            </tbody>
                          </table>

                        </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>

            )}
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              {language === "English" ? " Close " : "Close à¤•à¤°à¤¾"}
            </Button>
            <Button variant="primary" onClick={handlePrint}>
              {language === "English" ? "Print" : "Print à¤•à¤°à¤¾"}
            </Button>
          </Modal.Footer>
        </Modal>

      </div>

    </div>
  );
};

export default BoardResult;






